import React from 'react'
import Nav from '../components/Nav'
import Footer from '../components/Footer'
import MainImg from '../components/MainImg'
import Form from '../components/Form'
const contact = () => {
  return (
    <div>
       <Nav/>
       <MainImg heading="CONTACT." text="Let's have a chat"/>
       <Form/>
      <Footer/>
    </div>
  )
}

export default contact
